"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponsServiceServer = exports.CouponsServiceDispatcher = exports.CouponsServiceClient = void 0;
var UserCouponsResponse_1 = require("./UserCouponsResponse");
var CouponTemplateID_1 = require("./CouponTemplateID");
var CouponClaimResponse_1 = require("./CouponClaimResponse");
var services_shared_1 = require("@playq/services-shared");
var BucketID_1 = require("./BucketID");
var BucketVersionDivergeFailure_1 = require("./BucketVersionDivergeFailure");
var NotEnoughItemsFailure_1 = require("./NotEnoughItemsFailure");
var UnknownItemsFailure_1 = require("./UnknownItemsFailure");
var CouponPurchaseResponse_1 = require("./CouponPurchaseResponse");
var BadCouponFailure_1 = require("./BadCouponFailure");
var InClaim = (function () {
    function InClaim(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.code = data.code;
        this.targetBucket = typeof data.targetBucket !== 'undefined' ? new BucketID_1.BucketID(data.targetBucket) : undefined;
        this.targetBucketVersion = typeof data.targetBucketVersion !== 'undefined' ? data.targetBucketVersion : undefined;
    }
    Object.defineProperty(InClaim.prototype, "code", {
        get: function () {
            return this._code;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field code is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field code expects type string, got ' + value);
            }
            this._code = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InClaim.prototype, "targetBucket", {
        get: function () {
            return this._targetBucket;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._targetBucket = undefined;
                return;
            }
            this._targetBucket = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InClaim.prototype, "targetBucketVersion", {
        get: function () {
            return this._targetBucketVersion;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._targetBucketVersion = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field targetBucketVersion expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field targetBucketVersion expects guid format, got ' + value);
            }
            this._targetBucketVersion = value;
        },
        enumerable: false,
        configurable: true
    });
    InClaim.prototype.serialize = function () {
        return {
            code: this.code,
            targetBucket: typeof this.targetBucket !== 'undefined' ? this.targetBucket.serialize() : undefined,
            targetBucketVersion: typeof this.targetBucketVersion !== 'undefined' ? this.targetBucketVersion : undefined
        };
    };
    return InClaim;
}());
var OutClaimHelpers = (function () {
    function OutClaimHelpers() {
    }
    OutClaimHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponClaimResponse_1.CouponClaimResponse || o instanceof BadCouponFailure_1.BadCouponFailure || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure || o instanceof BucketVersionDivergeFailure_1.BucketVersionDivergeFailure;
    };
    OutClaimHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutClaimHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponClaimResponse': return new CouponClaimResponse_1.CouponClaimResponse(content);
            case 'BadCouponFailure': return new BadCouponFailure_1.BadCouponFailure(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            case 'BucketVersionDivergeFailure': return new BucketVersionDivergeFailure_1.BucketVersionDivergeFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutClaim');
        }
    };
    return OutClaimHelpers;
}());
var InPurchase = (function () {
    function InPurchase(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new CouponTemplateID_1.CouponTemplateID(data.id);
        this.recipients = data.recipients.slice();
        this.costBucket = typeof data.costBucket !== 'undefined' ? new BucketID_1.BucketID(data.costBucket) : undefined;
        this.costBucketVersion = typeof data.costBucketVersion !== 'undefined' ? data.costBucketVersion : undefined;
    }
    Object.defineProperty(InPurchase.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPurchase.prototype, "recipients", {
        get: function () {
            return this._recipients;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field recipients is not optional');
            }
            this._recipients = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPurchase.prototype, "costBucket", {
        get: function () {
            return this._costBucket;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._costBucket = undefined;
                return;
            }
            this._costBucket = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPurchase.prototype, "costBucketVersion", {
        get: function () {
            return this._costBucketVersion;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._costBucketVersion = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field costBucketVersion expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field costBucketVersion expects guid format, got ' + value);
            }
            this._costBucketVersion = value;
        },
        enumerable: false,
        configurable: true
    });
    InPurchase.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            recipients: this.recipients.slice(),
            costBucket: typeof this.costBucket !== 'undefined' ? this.costBucket.serialize() : undefined,
            costBucketVersion: typeof this.costBucketVersion !== 'undefined' ? this.costBucketVersion : undefined
        };
    };
    return InPurchase;
}());
var OutPurchaseHelpers = (function () {
    function OutPurchaseHelpers() {
    }
    OutPurchaseHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponPurchaseResponse_1.CouponPurchaseResponse || o instanceof NotEnoughItemsFailure_1.NotEnoughItemsFailure || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure || o instanceof BucketVersionDivergeFailure_1.BucketVersionDivergeFailure;
    };
    OutPurchaseHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutPurchaseHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponPurchaseResponse': return new CouponPurchaseResponse_1.CouponPurchaseResponse(content);
            case 'NotEnoughItemsFailure': return new NotEnoughItemsFailure_1.NotEnoughItemsFailure(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            case 'BucketVersionDivergeFailure': return new BucketVersionDivergeFailure_1.BucketVersionDivergeFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutPurchase');
        }
    };
    return OutPurchaseHelpers;
}());
var InGetCoupons = (function () {
    function InGetCoupons(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InGetCoupons.prototype.serialize = function () {
        return {};
    };
    return InGetCoupons;
}());
var OutGetCouponsHelpers = (function () {
    function OutGetCouponsHelpers() {
    }
    OutGetCouponsHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof UserCouponsResponse_1.UserCouponsResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutGetCouponsHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetCouponsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'UserCouponsResponse': return new UserCouponsResponse_1.UserCouponsResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetCoupons');
        }
    };
    return OutGetCouponsHelpers;
}());
var CouponsServiceClient = (function () {
    function CouponsServiceClient(transport) {
        this._transport = transport;
    }
    CouponsServiceClient.prototype.getPackageName = function () { return CouponsServiceClient.PackageName; };
    CouponsServiceClient.prototype.getClassName = function () { return CouponsServiceClient.ClassName; };
    CouponsServiceClient.prototype.getFullClassName = function () { return CouponsServiceClient.FullClassName; };
    CouponsServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponsServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponsServiceClient.prototype.claim = function (code, targetBucket, targetBucketVersion) {
        var _this = this;
        var __data = new InClaim();
        __data.code = code;
        __data.targetBucket = targetBucket;
        __data.targetBucketVersion = targetBucketVersion;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponsServiceClient.ClassName, 'claim', __data)
                .then(function (data) {
                try {
                    resolve(OutClaimHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponsServiceClient.prototype.purchase = function (id, recipients, costBucket, costBucketVersion) {
        var _this = this;
        var __data = new InPurchase();
        __data.id = id;
        __data.recipients = recipients;
        __data.costBucket = costBucket;
        __data.costBucketVersion = costBucketVersion;
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponsServiceClient.ClassName, 'purchase', __data)
                .then(function (data) {
                try {
                    resolve(OutPurchaseHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponsServiceClient.prototype.getCoupons = function () {
        var _this = this;
        var __data = new InGetCoupons();
        return new Promise(function (resolve, reject) {
            _this._transport.send(CouponsServiceClient.ClassName, 'getCoupons', __data)
                .then(function (data) {
                try {
                    resolve(OutGetCouponsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    CouponsServiceClient.PackageName = 'net.playq.services.bookkeeper';
    CouponsServiceClient.ClassName = 'CouponsService';
    CouponsServiceClient.FullClassName = 'net.playq.services.bookkeeper.CouponsService';
    return CouponsServiceClient;
}());
exports.CouponsServiceClient = CouponsServiceClient;
var CouponsServiceDispatcher = (function () {
    function CouponsServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    CouponsServiceDispatcher.prototype.getSupportedService = function () {
        return 'CouponsService';
    };
    CouponsServiceDispatcher.prototype.getSupportedMethods = function () {
        return CouponsServiceDispatcher.methods;
    };
    CouponsServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "claim": {
                var obj_1 = new InClaim(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.claim(context, obj_1.code, obj_1.targetBucket, obj_1.targetBucketVersion)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutClaimHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "purchase": {
                var obj_2 = new InPurchase(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.purchase(context, obj_2.id, obj_2.recipients, obj_2.costBucket, obj_2.costBucketVersion)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPurchaseHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getCoupons": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getCoupons(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetCouponsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by CouponsServiceDispatcher."));
        }
    };
    CouponsServiceDispatcher.methods = [
        "claim",
        "purchase",
        "getCoupons"
    ];
    return CouponsServiceDispatcher;
}());
exports.CouponsServiceDispatcher = CouponsServiceDispatcher;
var CouponsServiceServer = (function (_super) {
    __extends(CouponsServiceServer, _super);
    function CouponsServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    CouponsServiceServer.prototype.claim = function (context, code, targetBucket, targetBucketVersion) {
        throw new Error('Not implemented.');
    };
    CouponsServiceServer.prototype.purchase = function (context, id, recipients, costBucket, costBucketVersion) {
        throw new Error('Not implemented.');
    };
    CouponsServiceServer.prototype.getCoupons = function (context) {
        throw new Error('Not implemented.');
    };
    return CouponsServiceServer;
}(CouponsServiceDispatcher));
exports.CouponsServiceServer = CouponsServiceServer;
//# sourceMappingURL=CouponsService.js.map